<template>
	<ion-page>
		<div class="forceupdate__wrapper">
			<img src="/assets/trackiwi_logo.png" class="forceupdate__logo" />

			<div class="forceupdate__text">
				<p>Deine trackiwi App ist veraltet und muss aktualisiert werden.</p>
			</div>

			<div class="forceupdate__footer" v-if="updateVersion">
				<ion-button v-if="platform == 'web'" class="text--large pill" color="secondary" @click="updatePwa()">Jetzt aktualisieren</ion-button>
				<ion-button v-if="platform == 'android'" class="text--large pill" color="secondary" :href="updateVersion.url_android" target="_blank">Jetzt aktualisieren</ion-button>
				<ion-button v-if="platform == 'ios'" class="text--large pill" color="secondary" :href="updateVersion.url_ios" target="_blank">Jetzt aktualisieren</ion-button>
				<p class="text--small">Deine Version: {{ appVersion }}, neueste Version: {{ updateVersion.version }}</p>
			</div>
		</div>
	</ion-page>
</template>

<script setup>
import { Capacitor } from "@capacitor/core"
import { StatusBar, Style } from "@capacitor/status-bar"
import { IonPage, IonButton, onIonViewDidEnter } from "@ionic/vue"
import { onMounted, ref } from "vue"
import { storeToRefs } from "pinia"
import { App } from "@capacitor/app"
import { useApiStore } from "@/stores/api"
import { useVersionStore } from "@/stores/version"

const { appVersion } = storeToRefs(useVersionStore())

const api = useApiStore()
const updateVersion = ref(null)
const platform = ref(null)

const updatePwa = () => {
	window.location.reload()
}

const setStatusBarColor = () => {
	if (Capacitor.isNativePlatform()) {
		StatusBar.setStyle({ style: Style.Dark })
	}
}

onMounted(async () => {
	setStatusBarColor()
	platform.value = Capacitor.getPlatform()
	checkVersion()
})

onIonViewDidEnter(() => {
	setStatusBarColor()
})

App.addListener("appStateChange", ({ isActive }) => {
	if (isActive) {
		setStatusBarColor()
		checkVersion()
	}
})

// check, if version is still deprecated
const checkVersion = async () => {
	try {
		const response = await api.dispatchWebsiteApiCall("get", "/api/app/checkupdate", { ts: Date.now() })

		if (!response.data.force_update) {
			window.location.href = "/"
		}

		updateVersion.value = response.data.latest_version
	} catch (e) {
		console.log("error while getting latest app version")
		console.log(e)
		return
	}
}
</script>

<style scoped>
.forceupdate__wrapper {
	position: fixed;
	display: grid;
	grid-template-columns: 100%;
	grid-template-rows: 20% calc(80% - 200px) 200px;
	width: 100vw;
	height: 100vh;
	min-height: 650px;
	background-color: #193729;
	background-image: url("/assets/login-background.jpg");
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center center;
}

.forceupdate__logo {
	width: 90%;
	max-width: 180px;
	align-self: end;
	justify-self: center;
}

.forceupdate__text {
	width: 90%;
	max-width: 300px;
	align-self: center;
	justify-self: center;
	text-align: center;
	font-size: 1.3em;
	font-weight: 600;
	color: #fff;
}

.forceupdate__footer {
	width: auto;
	align-self: center;
	justify-self: center;
	color: #fff;
	text-align: center;
}
</style>
